import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useCurrentOrgId } from "@/providers/auth/hooks";
import { useDomainServices } from "@/providers/DomainServices";

import { customFieldQueryKeys } from "./customFieldQueryKeys";

/**
 * Deletes a custom-field definition (by `field_id`) in the current org. On
 * success it invalidates the cached lists; `useCustomFields` then polls the row
 * Deleting -> gone, or surfaces a Failed status if the async teardown fails.
 */
export function useDeleteCustomField() {
  const { customFieldService } = useDomainServices();
  const queryClient = useQueryClient();
  const orgId = useCurrentOrgId();

  return useMutation<void, Error, string>({
    mutationFn: (fieldId) =>
      customFieldService.deleteCustomField(fieldId, { orgId }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: customFieldQueryKeys.lists(),
      });
    },
  });
}
